import $ from 'jquery';
import {isPhone} from '../useragent';
import Watcher from '../watcher';
import StickyGarage from '../sticky-garage';
import AutoplayVideo from '../video-autoplay';

const coverExists = $('.journal-cover').length > 0;
const biggerCover = $('.journal-cover .img-wrapper').hasClass('bigger-cover');

const watcher = new Watcher();

$('.new-scaling-layout .tiles .img-container').addClass('intro-riseup bottom-to-top');
if (isPhone) {
    $('.journal-intro').addClass('intro-riseup');
}

function switchTo(href: string) {
    $('#page-journal-index .new-scaling-layout').removeClass('active');
    $('#page-journal-index h1').removeClass('emerge-show');
    $('#page-journal-index .tiles .img-container').removeClass('intro-riseup-show');
    const $new = $(`${href}`);
    $new.addClass('active');
    $new.find('h1').addClass('emerge-show');
    $new.find('.tiles .img-container').addClass('intro-riseup-show');
}

// Intro Effekte triggern:
setTimeout(() => {
    $('#intro .emerge, .journal-cover .emerge').addClass('emerge-show');
    $('.journal-cover .intro-riseup').addClass('intro-riseup-show');
    $('.journal-intro').addClass('intro-riseup-show');
    switchTo(location.hash || '#inspiration');
}, 100);

$('#intro nav').on('click', 'a', function(e) {
    e.preventDefault();
    switchTo($(this).attr('href')!);
});

if(coverExists && !isPhone) {
    const SPEED = 1;
    const startWidth = biggerCover ? 87.5 : 62.5; //%
    const startHeight = biggerCover ? 87.5 : 65.5; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen
    watcher.add({
        // element: $('.journal-intro .spacer')[0],
        element: $('.journal-cover .content')[0],
        onProgress: (element, {introShortProgress, outroProgress}) => {
            // const progress = outroProgress;
            const progress = introShortProgress;
            const mask = $('.journal-cover .img-wrapper .mask')[0];
            const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
            const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

            mask.style.width = `${width}%`;
            mask.style.height = `${height}%`;
        },
    });
}

{
    const $images = $('.details-options .images .img-wrapper'); //TODO

    const SPEED = 1;
    const startHeight = 75; //%
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %
                mask.style.height = `${height}%`;
            },
        });
    });
}

if(coverExists && !isPhone) {
    new StickyGarage(watcher, $('.journal-cover')[0], $('.journal-intro')[0], {reverseGarage: true});
}

{
    const $images = $('section.new-scaling-layout .img-container');

    const SPEED = 1.2;
    const startWidth = 85; //%
    const startHeight = 85; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        const mask = $(ele).find('.mask')[0];
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

                mask.style.width = `${width}%`;
                mask.style.height = `${height}%`;
            },
        });
    });
}

$('section.new-scaling-layout .emerge:not(h1)').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            $(ele).addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});

// Videos einfügen:
const $videos = $('.new-scaling-layout video');

$videos.each((i, ele) => {
    const $video = $(ele) as JQuery<HTMLVideoElement>;
    if (!$video.length) return;
    new AutoplayVideo($video);
});

// Workaround für Teaser-Klick-Problem auf iPad:
// Sonst muss man 2x klicken, damit sich der Teaser-Link öffnet
document.querySelectorAll('a.link-wrap').forEach(link => {
    link.addEventListener('touch', (event) => { // funktioniert nur mit 'touchstart', aber dann kann man darauf nicht mehr scrollen
        (link as HTMLAnchorElement).focus();
        event.preventDefault();
        (link as HTMLAnchorElement).click();
    });
});
